import { checkHttpStatus, parseJSON, objectToQueryString, expiredToken, okResponse, ok } from '../../utils/response';
import { Token, UserCode, Company, EmployeeCode, EmployeeId, SessionGuid, Worksite } from '../../utils/users';
import { errorResponse } from '../../utils/response';
import * as StatusCode from '../../scripts/StatusCode';
import * as storage from '../../utils/storage'
import { sessionLogout, loginUserSuccess } from '../../actions/login';
import { IsEnglish } from '../../utils/language';

export function isAuthenticated(redirect = true) {
    const token = Token();

    if (token !== null) {

        let url = 'authentication/isAuthenticated?' + objectToQueryString({ token: token, userCode: UserCode() });

        return fetch(url, {
            method: 'get',
            credentials: 'include',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })
            .then(checkHttpStatus)
            .then(parseJSON)
            .then(response => {
                try {
                    if (response.status === StatusCode.STATUS_UNAUTHORIZED) {
                        if (redirect) {
                            logout(true);
                        }

                        return false;
                    }

                    if (response.status == StatusCode.STATUS_INTERNALSERVERERROR) {
                        logout(true);
                    }

                    return true;
                } catch (e) {
                    errorResponse(response);

                    return false;
                }
            })
            .catch(error => {
                errorResponse(error);

                return false
            })
    }
    else {
        return new Promise((resolve) => {
            logout(true);

            return false;
        });
    }
}

export function generateToken(company) {
    const conn = storage.getConnectionString().value;

    return fetch('authentication/generateTokenCompany', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            userCode: UserCode(),
            company: company,
            sessionGuid: SessionGuid(),
            conn: conn,
            token: Token()
        })
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                if (response == "undefined") {
                    alert('undefined');
                }

                const dataCompany = response.companies[0];

                loginUserSuccess(response.token, response.isTermsValid,
                    IsEnglish() ? response.termsEn : response.termsFr,
                    IsEnglish() ? response.legalInfoEn : response.legalInfoFr,
                    response.showDateStatementTerms,
                    response.showDateStatementLegalInfo,
                    dataCompany.scheduleReturnDate,
                    dataCompany.useGeolocation,
                    dataCompany.useGeolocationZone,
                    dataCompany.creditCardSupport,
                    dataCompany.punchByTime,
                    dataCompany.colorCalendar,
                    dataCompany.useWorkInstructions,
                    dataCompany.isDisplayMedicalData,
                    dataCompany.isDisplayDistributionSlip,
                    dataCompany.isDisplayPreferenceCommunication,
                    dataCompany.isCCQ,
                    dataCompany.isPartialRequestHoursUsed,
                    dataCompany.taxationProvince,
                    dataCompany.isMandatoryPhoneCellPerso,
                    dataCompany.isMandatoryEmailPerso,
                    dataCompany.isMandatorySMSPerso,
                    dataCompany.communicationPreference,
                    response.userName,
                    dataCompany.isDisplayPayAdvanceVacation,
                    dataCompany.isUsePartialRequest,
                    dataCompany.isDisplayPayablesHours,
                    dataCompany.isUseMaterialResourceTimesheet,
                    dataCompany.isDisplayPayablesHours,
                    response.notificationPublicKey,
                    response.isNotificationActivate,
                    dataCompany.isDisplayFlagFullTime,
                    dataCompany.isProfileConsultationMode,
                    dataCompany.isDisplayBankOthers,
                    dataCompany.isDisplayBankVacation,
                    dataCompany.useServiceProvider,
                    dataCompany.useGeolocationMandatory
                );

                return response;
            } catch (e) {
                errorResponse(response);

                return false;
            }
        })
        .catch(error => {
            errorResponse(error);

            return false
        })
}

export function renewToken() {
    return fetch('authentication/renewToken', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            userCode: UserCode(),
            employeeCode: EmployeeCode(),
            employeeId: EmployeeId(),
            company: Company(),
            sessionGuid: SessionGuid(),
            worksite: Worksite(),
            token: Token()
        })
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                if (response == "undefined") {
                    alert('undefined');
                }

                return response;
            } catch (e) {
                errorResponse(response);

                return false;
            }
        })
        .catch(error => {
            errorResponse(error);

            return false
        })
}

export function getHashClient(userCode, conn, isPrefixDB) {
    let url = 'authentication/getClientHashKey?' + objectToQueryString({userCode, conn, isPrefixDB });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(parseJSON)
        .then(response => {
            try {
                storeClientHashKey(response.key)
                storeMinLengthPassword(response.minPasswordLength)
                storeIsPasswordComplex(response.isComplexPassword)

                return ok();
            } catch (e) {
                return errorResponse(response);
            }
        })
        .catch(error => {
            return errorResponse(error);
        })
}

export function getInitialConfig(conn) {
    let url = 'authentication/getInitialConfig?' + objectToQueryString({ conn: conn });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(parseJSON)
        .then(response => {
            try {
                return okResponse(response);
            } catch (e) {
                return errorResponse(response);
            }
        })
        .catch(error => {
            return errorResponse(error);
        })
}


export function logout(expire = false) {
    sessionLogout();
    if (expire) {
        window.location.href = 'login/1';
    }
    else {
        window.location.href = 'login';
    }
}

export async function logoutSSO(instance) {
    instance.logoutPopup().then(() => {
        logout();
    });
}

function storeClientHashKey(key) {
    storage.saveClientHashKey(key);
}

function storeMinLengthPassword(value) {
    storage.saveMinLengthPassword(value);
}

function storeIsPasswordComplex(value) {
    storage.saveIsPasswordComplex(value);
}